import {Injectable, signal} from "@angular/core";
import {
    AuthService,
    CustomSettingsService,
    PaginationService,
    Role,
    RoleService,
    SimpleEntityService,
} from "@customcoding/shared";
import { HttpClient } from "@angular/common/http";
import { Volunteer, VolunteerCreateRequest, VolunteerUpdateRequest } from "../shared/models/volunteer.obj";
import { firstValueFrom, Subscription} from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class VolunteerService extends SimpleEntityService<Volunteer, VolunteerCreateRequest, VolunteerUpdateRequest> {

    _subscriptions = new Subscription();

    volunteerRoles = signal<Role[]>([]);


    constructor(
        http: HttpClient,
        pagination: PaginationService,
        private roleService: RoleService,
        private authService: AuthService,
        private settingsService: CustomSettingsService
    ) {
        super(http, pagination, '/api/golden-me/dashboard/');
        //this.getVolunteerRoles();
    }

    getAll() {
        return this.http.get<Volunteer[]>(this.apiEndpoint + 'volunteer?isPaginated=0');
    }

    getVolunteersByEvent(eventId: number) {
        return this.http.get(this.apiEndpoint + `event/${eventId}/volunteer?isPaginated=0`);
    }

    addVolunteerToPhase(eventId: number, phaseId: number) {
        return this.http.post(this.apiEndpoint + `event/${eventId}/phase/${phaseId}/add-volunteer`, {});
    }

    removeVolunteerFromPhase(eventId: number, phaseId: number) {
        return this.http.delete(this.apiEndpoint + `event/${eventId}/phase/${phaseId}/remove-volunteer`);
    }

    toggleVolunteerConfirmationStatus(phaseId: number, volunteerId: number, isConfirmed: boolean) {
        const body = {isConfirmed: isConfirmed, _method: "PATCH"};
        return this.http.post(this.apiEndpoint+ `phase/${phaseId}/volunteer/${volunteerId}`, body);
    }

    getVolunteerForProfile(volunteerId: number) {
        return this.http.get<Volunteer>(this.apiEndpoint + 'volunteer/' +volunteerId);
    }

    updateVolunteerFromProfile(volunteerId: number, data: any ) {
        const body = {
           ...data,
            _method: "PATCH"
        };
        return this.http.post(this.apiEndpoint + 'volunteer/' + volunteerId, body);
    }

    async isVolunteer(): Promise<boolean> {

        //wait for current user, check roles afterwards:
        const user = await this.authService.getCurrentUserAsync();
        const setting = await firstValueFrom(this.settingsService.getSettingByKey('GOLDEN_ME_VOLUNTEER_ROLES'));

        const userRoleIds = user.roles.map(role => role.id);
        const volunteerRoleIds = setting.value?.map(id => Number(id)) || [];

       // const volunteerRoleIds = this.volunteerRoles().map(role => role.id);

        return userRoleIds.some(id => volunteerRoleIds.includes(id));

        //or:
        /*
           return this.roleService.currentUser.roles.some(userRole =>
        this.volunteerRoles().find(volunteerRole => volunteerRole.id === userRole.id)
    );

         */
    }

    /* TODO : WIP

    private checkIfVolunteer(): Promise<boolean> {
        return Promise.all([
            this.userService.  toPromise(),
            this.roleService.all().toPromise(),
            this.settingsService.getSettingByKey('GOLDEN_ME_VOLUNTEER_ROLES').toPromise()
        ]).then(([userRoles, allRoles, volunteerSetting]) => {
            const volunteerRoleIds = allRoles
                .filter(role => volunteerSetting.value?.includes(role.id.toString()))
                .map(role => role.id);

            const userRoleIds = userRoles.map(role => role.id);

            return userRoleIds.some(id => volunteerRoleIds.includes(id));
        });
    }
    */




}
